// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotOutlinedSvg from "@ant-design/icons-svg/es/asn/FunnelPlotOutlined";
import AntdIcon from '../components/AntdIcon';

var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotOutlinedSvg
  }));
};

FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
export default React.forwardRef(FunnelPlotOutlined);